// extracted by css-extract-rspack-plugin
var _1 = "eo";
var _2 = "ep";
var _3 = "eq";
var _4 = "en";
var _5 = "eh";
var _6 = "el";
var _7 = "em";
var _8 = "eg";
var _9 = "ek";
export { _1 as "brandsCount1", _2 as "brandsCount2", _3 as "carouselContainer", _4 as "count", _5 as "discounts", _6 as "image", _7 as "name", _8 as "shoppingMallTabBrandsItemComponent", _9 as "table" }
